
import Vue from 'vue';
import { Data as ArticleData } from '@root/modules/article/types/article';
import { lussUrl } from '@root/modules/article/utils/ArticleTextToSpeech';

interface Props {
  article: ArticleData;
}

interface Data {
  showPlayer: boolean;
  title: string | null;
  hasTtsFile: boolean;
}

interface Computed {
  showListenButton: boolean;
}

interface Methods {
  setFontSize: () => void;
  handleShowPlayer: () => void;
  getTTSUrl: () => string;
  checkIfHasTtsFile: () => Promise<boolean>;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  props: {
    article: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showPlayer: false,
      title: typeof window !== 'undefined' ? window.document.title.replace('"', '') : null,
      hasLussFile: false,
      hasTtsFile: false,
    };
  },
  computed: {
    showListenButton() {
      return this.$channelConfig('page').article.component.info.listenIconShow && this.hasTtsFile;
    },
  },
  async mounted() {
    this.hasTtsFile = await this.checkIfHasTtsFile();
  },
  methods: {
    setFontSize() {
      this.$emit('set-font-size');
    },
    handleShowPlayer() {
      this.showPlayer = !this.showPlayer;
    },
    getTTSUrl() {
      if (this.article.content.paywall.enabled) {
        return `//tts.delfi.lt/api/get/${this.article.id}?t=${Date.now()}`;
      }

      return lussUrl(this.article.id);
    },
    async checkIfHasTtsFile() {
      let result = false;

      const url = this.article.content.paywall.enabled ? `//tts.delfi.lt/api/get/${this.article.id}?t=${Date.now()}` : lussUrl(this.$props.article.id);
      await fetch(url)
        .then((response) => {
          if (response.ok) {
            result = true;
          } else if (response.status === 404) {
            result = false;
          } else {
            result = false;
          }
        })
        .catch(() => {
          result = false;
        });

      return result;
    },
  },
});
